import React from 'react'
import PropTypes from 'prop-types'
import { FileInput, ButtonProgress } from './'
import { rest } from '../../lib'

class FileUploader extends React.Component {
  constructor(...args) {
    super(...args)
    this.file = null
    this.state = {
      loading: false,
      progress: 0,
      error: ''
    }
  }
  componentDidMount = () => this._isMount = true
  componentWillUnmount = () => this._isMount = false

  handleChange = f => this.file = f

  onProgress = e => {
    const percent = parseInt((e.loaded / e.total * 100), 0)
    this._isMount && this.setState({ progress: percent >= 100 ? 0 : percent })
  }

  upload = e => {
    e.preventDefault()
    e.target.blur()

    const { url, params, onSend, onError, onFinish } = this.props
    if (this.state.progress > 0 || !this.file || !url) return

    onSend(url, this.file.name)
    this._isMount && this.setState({ loading: true, progress: 0, error: '' })

    rest.upload(url, params, this.file, this.onProgress)
    .then(res => {
      if ('error' in res) {
        this._isMount && this.setState({ loading: false, progress: 0, error: 'Aborted' })
        onError(url, res.error)
      } else {
        this._isMount && this.setState({ loading: false, progress: 0, error: '' })
        onFinish(url, res)
      }
    }).catch(e => {
      onError(url, e.statusText)
      this._isMount && this.setState({ loading: false, progress: 0, error: 'Aborted' })
    })
  }

  render() {
    const { loading, progress, error } = this.state
    return (
      <div className='input-group'>
        <FileInput {...this.props} onChange={this.handleChange}/>
        <span className='input-group-btn'>
          <ButtonProgress {...this.props} loading={loading} progress={progress} error={error} onClick={this.upload}>Upload</ButtonProgress>
        </span>
      </div>
    )
  }
}

FileUploader.defaultProps = {
  accept: '',
  onSend: () => {},
  onFinish: () => {},
  onError: () => {}
}

FileUploader.propTypes = {
  url:   PropTypes.string,
  accept:   PropTypes.string,
  onSend: PropTypes.func,
  onFinish: PropTypes.func,
  onError: PropTypes.func
}

export default FileUploader



// WEBPACK FOOTER //
// ./src/components/widgets/FileUploader.js